// Copyright (c) 2022 by Move Closer

import { Component, Vue } from 'vue-property-decorator'

/**
 * Extendable component that's capable of receiving the `color` @Prop
 * and transforming it into the target CSS class using the specified registry.
 *
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
@Component<UseColor>({ name: 'UseColor' })
export class UseColor extends Vue {
  protected readonly color?: string

  public get colorClassName (): string {
    // lirene
    // [AllowedColor.Black]: 'text-black',
    // [AllowedColor.Body]: 'text-body',
    // [AllowedColor.Primary]: 'text-primary',
    // [AllowedColor.White]: 'text-white'
    if (typeof this.color !== 'string') {
      return ''
    }

    return `text-${this.color}`
  }
}
